export default "__VITE_ASSET__C7Sy$4mD__"